import React from 'react';
import { processSteps } from '../../data/mock';
import { ArrowRight } from 'lucide-react';

const ProcessSection = () => {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="inline-flex items-center bg-blue-50 text-blue-700 px-4 py-2 rounded-full text-sm font-medium mb-6">
            Notre processus
          </div>
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6">
            Simple, rapide et
            <span className="text-blue-600"> efficace</span>
          </h2>
          <p className="text-slate-600 text-lg">
            De la prise de contact à la remise du rapport vidéo, notre processus est conçu pour votre confort.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {processSteps.map((step, index) => (
            <div key={step.id} className="relative">
              {/* Connector Line */}
              {index < processSteps.length - 1 && (
                <div className="hidden lg:block absolute top-12 left-[60%] w-[80%] h-0.5 bg-blue-200">
                  <ArrowRight className="absolute -right-3 -top-2 w-5 h-5 text-blue-400" />
                </div>
              )}
              
              <div className="bg-slate-50 rounded-2xl p-8 hover:bg-blue-50 transition-colors duration-300 h-full">
                {/* Number */}
                <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-blue-700 rounded-2xl flex items-center justify-center mb-6 shadow-lg">
                  <span className="text-2xl font-bold text-white">{step.number}</span>
                </div>
                
                <h3 className="text-xl font-bold text-slate-800 mb-3">{step.title}</h3>
                <p className="text-slate-600">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
